@if (outcomeData) {
  <div class="z-container-box z-fx-col z-fx-gap-24">
    @if ((ss.isFree | async) === false && (ss.logo | async).url && outcomeData?.type !== types.OUTCOME) {
      @if (
        (null | translateText: 'image' : outcomeData) || outcomeData?.image?.url || outcomeData?.videoEmbed?.videoId
      ) {
        <div
          class="z-team-image z-team-image--small"
          [style.background-image]="(ss.logo | async).image | safeStyle"
        ></div>
      }
    }
    <div class="z-outcome-header z-fx-col z-fx-gap-8 z-fx-center-center z-fx-none">
      <media-cta
        [data]="outcomeData"
        [fallbackImage]="
          (ss.isFree | async) === false && outcomeData?.type !== types.OUTCOME ? (ss.logo | async)?.url : ''
        "
        (newAnswerer)="newAnswerer.emit()"
      >
        @if (outcomeData?.type === types.OUTCOME) {
          @if ((outcomeRank | async) != null) {
            <div
              class="z-score-text z-texts-header z-fx-center-center"
              [style.color]="(ss.colors | async).text80"
              [style.background-color]="(ss.colors | async).mood"
            >
              {{ outcomeRank | async | json }}
            </div>
          } @else {
            @if ((outcomeScore | async) != null) {
              <div
                class="z-score-text z-text-player z-fx-center-center"
                [style.color]="(ss.colors | async).text80"
                [style.background-color]="(ss.colors | async).mood"
              >
                {{ outcomeScore | async | percent: '1.0-0' }}
              </div>
            } @else {
              @if ((outcomeCorrect | async) != null) {
                <div
                  class="z-score-text z-text-player z-fx-center-center"
                  [style.color]="(ss.colors | async).primary"
                  [style.background-color]="(ss.colors | async).mood80"
                >
                  {{ outcomeCorrect | async }}
                </div>
              }
            }
          }
        }
      </media-cta>
      @if ((outcomeData?.type === types.OUTCOME && isFirstOutcome) || outcomeData?.type === types.GOODBYE) {
        @if (ss.restartDelay$ | async; as delay) {
          <basic-button class="z-cta-button z-restart-cta" (click)="openCtaLink('restart')">
            {{ 'Restart' | translateText: 'restartSurvey' }} ({{ delay }})
          </basic-button>
        }
      }
    </div>
    <div class="z-fx-col z-fx-gap-24 z-fx-auto">
      <div class="z-fx-col z-fx-gap-16">
        @if (outcomeData.showTitle !== false) {
          <div
            class="z-texts-header z-fx-auto"
            [innerHTML]="outcomeData.title | translateText: 'title' : outcomeData | formatText | safeHtml"
            [style.color]="(ss.colors | async).text"
          ></div>
        }
        <share-buttons [outcomeData]="outcomeData"></share-buttons>
      </div>
      <div
        class="z-texts-paragraph z-fx-auto"
        [innerHTML]="outcomeData?.content | translateText: 'content' : outcomeData | formatText | safeHtml"
        [style.color]="(ss.colors | async).text"
      ></div>
      @if (ss.showPromoText | async) {
        <promo-text></promo-text>
      }
    </div>
  </div>
}
